import React from "react";
import Hero from "./components/Hero";
import Expect from "./components/Expect";
import Themes from "./components/Themes";
import About from "./components/About";
import Company from "./components/Company";
import Info from "../Agenda/components/Info";

export default function Home() {
  return (
    <>
      <Hero />
      <Expect />
      <Themes />
      <Info backgroundColor="#ffffff" />
      {/* <Company />
      
      {/* <About /> */}
    </>
  );
}
